"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getZodUtcDateTimeSchema = void 0;
var zod_1 = __importDefault(require("zod"));
var luxon_1 = require("luxon");
var dates_1 = require("../dates");
/**
 * This doesn't use `z.date() or `z.datetime()` as this doesn't care about
 * tz offsets. It just expects a UTC date.
 * @param opts
 */
function getZodUtcDateTimeSchema(opts) {
    if (opts === void 0) { opts = {}; }
    var targetFormat = dates_1.cDefaultUtcDateTimeLuxonFormat;
    var exampleFormat = "2024-08-01 12:02:04";
    var defaultErrorMessage = "Invalid input: the date should a string in the following format: '".concat(targetFormat, "'. For example: ").concat(exampleFormat, ".");
    return zod_1.default
        .any({
        invalid_type_error: opts.errorMessage || defaultErrorMessage,
        description: defaultErrorMessage,
        required_error: "Required"
    })
        .transform(function (value) {
        if (typeof value !== "string") {
            return false;
        }
        var parsedDate = luxon_1.DateTime.fromFormat(value, targetFormat, {
            zone: "utc",
            setZone: true,
        });
        if (!parsedDate.isValid) {
            return false;
        }
        if (opts.outputJsDate) {
            return parsedDate.toJSDate();
        }
        return value;
    })
        .refine(function (value) { return value !== false; }, {
        message: opts.errorMessage || defaultErrorMessage,
    });
}
exports.getZodUtcDateTimeSchema = getZodUtcDateTimeSchema;
